import type { EmploymentTemplateSalary } from "services/api/company/staff.service";

const AGE_SALARY_REQUIREMENT_TYPE = "Age";
const EXPERIENCE_SALARY_REQUIREMENT_TYPE = "Experience";

/**
 * Returns the template value unless it is unset (null/empty/"Undefined"), in
 * which case the fallback is used.
 */
export const toTemplateEnumOrFallback = <TFallback extends string | undefined>(
  value: string | null,
  fallback: TFallback,
): string | TFallback => {
  if (value == null || value.length === 0 || value === "Undefined") {
    return fallback;
  }

  return value;
};

/**
 * Filters template salaries by the worker's age.
 */
export const filterTemplateSalariesByAge = (
  salaries: EmploymentTemplateSalary[],
  workerAge: number | null,
): EmploymentTemplateSalary[] => {
  if (workerAge == null) return salaries;

  const matchesAnyAgeRequirement = salaries.some(
    (salary) =>
      salary.requirementType === AGE_SALARY_REQUIREMENT_TYPE &&
      salary.requirement === workerAge,
  );

  return salaries.filter((salary) => {
    if (salary.requirementType === AGE_SALARY_REQUIREMENT_TYPE) {
      return salary.requirement === workerAge;
    }
    if (salary.requirementType === EXPERIENCE_SALARY_REQUIREMENT_TYPE) {
      return !matchesAnyAgeRequirement;
    }
    return true;
  });
};
